import {ref, html, clone, traverse, text as text$1, after, effect, on, replace, show, append, css, define} from "@intrnl/velvet/internal";
import ScoreSelector from './ScoreSelector.velvet';
import {feedbacks, generateUUIDv4} from '../store/FeedbackStore.js';
let template0 = html("<form> <label for=field>How would you rate our services?</label> <x></x> <div class=input-group> <input id=field type=text placeholder='The service is...' autofocus /> <button type=submit>Add</button> </div> <!> </form>");
let template1 = html("<p class=error><!></p>");
let style0 = css("form{background-color:#fff;padding:16px;border-radius:4px}label{font-weight:600;display:block;margin-bottom:8px}.input-group{display:flex;gap:8px;margin-top:16px}button,input{height:36px;box-sizing:border-box;outline-width:2px;outline-color:#d42560}input{flex-grow:1;padding:4px 8px;border:1px solid #989898;border-radius:4px}button{cursor:pointer;user-select:none;color:#fff;background-color:#e25b88;padding:4px 16px;border:0;border-radius:4px;outline-offset:2px}button:hover{background-color:#ea86a7}.error{font-size:14px;color:#ed143d;margin:8px 0 0}");
function setup($$root, $$host) {
  let text = ref('');
  let score = ref(null);
  let error = ref(null);
  function handleSubmit(ev) {
    ev.preventDefault();
    const trimmed = text.v.trim();
    if (trimmed.length < 1) {
      error.v = 'You need to fill out the feedback message!';
      return;
    }
    if (score.v == null) {
      error.v = 'You need to give a score!';
      return;
    }
    const item = {
      id: generateUUIDv4(),
      message: trimmed,
      score: score.v,
      date: new Date()
    };
    feedbacks.update($feedbacks => {
      return [item, ...$feedbacks];
    });
    text.v = '';
    score.v = null;
    error.v = null;
  }
  let fragment0 = clone(template0);
  let child0 = new ScoreSelector();
  let marker0 = traverse(fragment0, [0, 3]);
  let child1 = traverse(fragment0, [0, 5, 1]);
  let marker2 = traverse(fragment0, [0, 7]);
  let child3 = traverse(fragment0, [0]);
  let block1 = $$root => {
    let fragment1 = clone(template1);
    let marker1 = traverse(fragment1, [0, 0]);
    let child2 = traverse(fragment1, [0]);
    text$1(marker1, () => error.v);
    after($$root, fragment1);
    return child2;
  };
  effect(() => child0["value"] = score.v);
  on(child0, "update:value", event => score.v = event.detail);
  replace(marker0, child0, true);
  effect(() => child1["value"] = text.v);
  on(child1, "input", () => text.v = child1.value);
  show(marker2, () => error.v ? block1 : null);
  on(child3, "submit", handleSubmit);
  append($$root, fragment0);
}
export default define("x-feedback-form", setup, {}, [style0]);
